// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AutofocusController from "./autofocus_controller"
application.register("autofocus", AutofocusController)

import AutoscrollController from "./autoscroll_controller"
application.register("autoscroll", AutoscrollController)

import AutosizeController from "./autosize_controller"
application.register("autosize", AutosizeController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FormController from "./form_controller"
application.register("form", FormController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SideMenuController from "./side_menu_controller"
application.register("side-menu", SideMenuController)

import SidePanelController from "./side_panel_controller"
application.register("side-panel", SidePanelController)
